import clsx from 'clsx';
import style from './chips.module.scss';
import { ChipsProps } from './chips';

export const Chips = (props: ChipsProps) => {
  const { Icon, colorSchema = 'default', disabled } = props;

  return (
    <div
      data-test-id={props.testId ? `${props.testId}-chip` : 'chip'}
      aria-disabled={props.disabled}
      aria-checked={props.checked}
      role={!disabled && props.onClick ? 'button' : undefined}
      className={clsx(style.chip, {
        [style.blue]: colorSchema === 'blue',
        [style.green]: colorSchema === 'green',
      }, props.className)}
      onClick={disabled ? undefined : props.onClick}
    >
      {Icon && <Icon className={style.icon} />}
      <span className={style.chipText}>{props.text}</span>
    </div>
  );
};
